import { IApplicationState } from '../../types/redux';

export function getBanks(state: IApplicationState) {
  const {
    newbuilding: { banks },
  } = state;

  return banks;
}
